/* eslint-disable no-console,no-unused-vars */
import {dataAPI} from './api';
import {download} from '../lib/downloadLogic';


function newObject(data){
    const dataChange= Object.keys(data)
        .map(function(value) {
            return {value : value,label : data[value]};
        });
    return dataChange;
}


export function loadDataFromAPI ( filters, username, timestamp, pageSize, pageOffset, firstSearch, n) {
    const filtersQueryString = Object.keys(filters).map( filterKey =>
        !filters[filterKey] ? '' : filters[filterKey].length === 0 ? '' : filterKey + '=' + (Array.isArray(filters[filterKey]) ?  filters[filterKey].map(index => index.value) : filters[filterKey].value )+ '&'
    ).join('').slice(0,-1);
    //console.log("filters query string: ", filtersQueryString);
    const queryString = `${filtersQueryString}&firstTimeSearch=${firstSearch}&pageSize=${pageSize}&pageOffset=${pageOffset}&fileName=${username}_${timestamp}`;
    //console.log("query string: ",  queryString);
    return new Promise ((resolve, reject) =>{
        dataAPI({
            method : 'get',
            url    : `loadData?${queryString}`
        })
            .then(response => {
                //console.log("Success");
                //console.log(response.data);
                resolve(response.data);
            })
            .catch((error) => {
                console.log("Search error ", error.response.status);
                console.log("Search n ", n);
                if(n === 1 || error.response.status === 404) return reject(error.response.status);
                resolve(loadDataFromAPI (filters, username, timestamp, pageSize, pageOffset, firstSearch, n-1));
                //resolve(defaultData);
            });
    });

}

export function loadTestRequestIdFilterAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadTestRequestIdFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(response.data.map(value => ({value, label : value})));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadTestRequestIdFilterAPI(n-1));
            });
    });
}
export function loadSuppliedMaterialNumberAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadSuppliedMaterialNumberFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(response.data.map(value => ({value, label : value})));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadSuppliedMaterialNumberAPI(n-1));
            });
    });
}
export function loadNikePPSItemNumberAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadNikePPSItemNumberFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(response.data.map(value => ({value, label : value})));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadNikePPSItemNumberAPI(n-1));
            });
    });
}
export function loadTestRequestSeasonAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadSeasonFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(response.data.map(value => ({value, label : value})));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadTestRequestSeasonAPI(n-1));
            });
    });
}
export function loadTestTypeAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadTestTypeFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadTestTypeAPI(n-1));
            });
    });
}
export function loadEndUseAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadEndUseFilterData'
        })
            .then(response => {
                //console.log("End use load: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadEndUseAPI(n-1));
            });
    });
}

export function loadMaterialTypeAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadMaterialTypeFilterData'
        })
            .then(response => {
                //console.log("load MY: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadMaterialTypeAPI(n-1));
            });
    });
}
export function loadSuppliedLocationAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadSupplierLocationFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadSuppliedLocationAPI(n-1));
            });
    });
}
export function loadLabAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadLabFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(response.data.map(value => ({value, label : value})));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadLabAPI(n-1));
            });
    });
}
export function loadLabTestStateAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadLabTestStateFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadLabTestStateAPI(n-1));
            });
    });
}

export function loadLabTestStatusAPI(n) {
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : 'loadLabTestStatusFilterData'
        })
            .then(response => {
                // console.log("load: ", response.data);
                resolve(newObject(response.data));
            })
            .catch(error => {
                console.log("error ", error.response.status);
                if(n === 1 || error.response.status === 500) return reject(error);
                resolve(loadLabTestStatusAPI(n-1));
            });
    });
}

export function createSelectedPDF(username, timestamp, n=5) {
    const queryString = `fileName=${username}_${timestamp}&emailAddress=${username}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : `generateSelectedPDF?${queryString}`
        })
            .then(response => {
                resolve(response.status);
            })
            .catch((error) => {
                if(n === 1 || (error.response.status >= 400 && error.response.status < 500)) return reject(error);
                resolve(createSelectedPDF( username, timestamp,n-1));
            });
    });
}

export function createAllPDF(username, timestamp, n=5) {
    const queryString = `fileName=${username}_${timestamp}&emailAddress=${username}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : `generateAllPDF?${queryString}`
        })
            .then(response => {
                resolve(response.status);
            })
            .catch((error) => {
                if(n === 1 || (error.response.status >= 400 && error.response.status < 500)) return reject(error);
                resolve(createAllPDF( username, timestamp,n-1));
            });
    });
}

export function cacheRowIDs(username, timestamp, rowIDs, n) {
    const queryString = `fileName=${username}_${timestamp}&rowIds=${rowIDs}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : `cacheRowIDs?${queryString}`
        })
            .then(response => {
                //console.log("Success");
                resolve(response.status);
            })
            .catch((error) => {
                if(n === 1 || error.response.status === 404) return reject(error);
                resolve(cacheRowIDs(username, timestamp, rowIDs,n-1));
            });
    });
}

export function uncacheRowIDs(username, timestamp, rowIDs, n) {
    const queryString = `fileName=${username}_${timestamp}&rowIds=${rowIDs}`;
    return new Promise ((resolve, reject) => {
        console.log('api username ', username);
        dataAPI({
            method : 'get',
            url    : `uncacheRowIDs?${queryString}`
        })
            .then(response => {
                //console.log("Success");
                resolve(response.status);
            })
            .catch((error) => {
                console.log("retry ", n);
                console.log("username ", username);
                if(n === 1 || error.response.status === 404) return reject(error);
                resolve(uncacheRowIDs(username, timestamp, rowIDs, n-1));
            });
    });
}

export function createExcelFile(username, timestamp,n) {
    const queryString = `fileName=${username}_${timestamp}&emailAddress=${username}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : `downloadResultsExcel?${queryString}`
        })
            .then(response => {
                resolve(response.status);
            })
            .catch((error) => {
                console.log("error ", error.response.status);
                if(n === 1 || (error.response.status >= 400 && error.response.status < 500)) return reject(error);
                resolve(createExcelFile( username, timestamp,n-1));
            });
    });
}
function delay(t, v) {
    return new Promise(function(resolve) {
        setTimeout(resolve.bind(null, v), t);
    });
}

export function cacheStatus(filters,  username, timestamp, n, cacheStartTime) {
    if(n==1){
        cacheStartTime = performance.now();
    }
    let timeTaken = (performance.now() -  cacheStartTime)/1000;
    const filtersQueryString = Object.keys(filters).map( filterKey =>
        filters[filterKey].length === 0  ? '' : filterKey + '=' + filters[filterKey].map(index => index.value) + '&'
    ).join('').slice(0,-1);
    const queryString = `${filtersQueryString}&fileName=${username}_${timestamp}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method  : 'get',
            url     : `cachingStatus?${queryString}`,
            timeout : 5000
        })
            .then(response => {
                if(response.data != 'Cached') {
                    console.log("timeTaken",timeTaken);
                    if(timeTaken >= 300){
                        reject("Data caching error");
                    }else{
                        return delay(5000).then(function () {
                            resolve(cacheStatus(filters, username, timestamp, n + 1, cacheStartTime));
                        });
                    }
                }
                else{
                    resolve(response);
                }
            })
            .catch((error) => {
                if(error.message.includes("timeout")){
                    resolve(cacheStatus(filters, username, timestamp, n + 1, cacheStartTime));
                }else{
                    return reject(error);
                }
                console.log("Catch n ", n);
            });

    });
}

export function cacheSearchResults(filters,  username, timestamp, n) {
    const filtersQueryString = Object.keys(filters).map( filterKey =>
        filters[filterKey].length === 0  ? '' : filterKey + '=' + filters[filterKey].map(index => index.value) + '&'
    ).join('').slice(0,-1);
    const queryString = `${filtersQueryString}&fileName=${username}_${timestamp}`;
    return new Promise ((resolve, reject) => {
        dataAPI({
            method : 'get',
            url    : `cacheSearchResults?${queryString}`
        })
            .then(response => {
                //console.log("Success");
                response.status == 200;
                resolve(response.status);
            })
            .catch((error) => {
                console.log("Catch error ", error.response.status);
                console.log("Catch n ", n);
                if(n === 1 || error.response.status === 404) return reject(error);
                //resolve(cacheSearchResults(filters,  username, timestamp,n-1));
            });

    });
}

export function downloadAllPDF(accessToken) {
    let filename = localStorage.getItem ('filename');
    return new Promise (() => {
        dataAPI({
            method       : 'get',
            responseType : 'blob',
            url          : `downloadArchivedPDF?fileName=${filename}`,
            headers      : {
                Authorization : 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?fileName=` + filename;
                window.history.pushState ({path : newUrl}, '', newUrl);
                download(response.data, filename);
            })
            .catch((error) => {
                console.log("Catch error ", error);
            });
    });
}

export function downloadSelectPDF(accessToken,fileExtension) {
    let filename = localStorage.getItem ('filename');
    return new Promise ((resolve, reject) => {
        dataAPI({
            method       : 'get',
            responseType : 'blob',
            url          : `downloadPDF?fileName=${filename}`,
            headers      : {
                Authorization : 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?fileName=`+ filename;
                window.history.pushState ({path : newUrl}, '', newUrl);
                download(response.data, filename);
            })
            .catch((error) => {
                console.log("Catch error ", error);
            });
    });
}

export function downloadExcel(accessToken) {
    let filename = localStorage.getItem ('filename');
    return new Promise (() => {
        dataAPI({
            method       : 'get',
            responseType : 'blob',
            url          : `downloadExcel?fileName=${filename}`,
            headers      : {
                Authorization : 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?fileName=` + filename;
                window.history.pushState ({path : newUrl}, '', newUrl);
                download(response.data, filename);
            })
            .catch((error) => {
                console.log("Catch error ", error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/APIs/dataHelper.js